import classes from './FeatureCard.module.css';

const FeatureCard = (props) => {
    return (
        <div className={classes.FeatureCard}>
            <div className={classes.CardIcon}>
                {props.icon}
            </div>
            <h4 className={classes.CardTitle}>
                {props.title}
            </h4>
            <p className={classes.CardText}>
                {props.description}
            </p>
        </div>
    );
}

export default FeatureCard;